/* Commons */
export const getProjectNameList = '/admin/projectName';
export const putSortList = '/admin/sort';
export const postPhoto = '/admin/photo';
export const postActiveStatus = '/admin/statusActive';
export const deletePhoto = (photoId: string | number) => `/admin/photo/${photoId}`;

/* Auth page */
export const postAdminLogin = '/admin/login';
export const postAdminLogout = '/admin/logout';
export const adminForgotPassword = '/admin/forgotPassword';

/* Banner manage */
export const getBannerList = '/admin/banner';
export const getBannerDetail = (bannerId: number | string) => `/admin/banner/${bannerId}`;
export const postBanner = '/admin/banner';
export const postBannerDetail = (bannerId: number | string) => `/admin/banner/${bannerId}`;
export const deleteBannerItem = (bannerId: number) => `/admin/banner/${bannerId}`;

/* News manage */
export const getNewsList = (newsType: number | string) => `/admin/news/${newsType}/type`;
export const getNewsDetail = (newsId: number | string) => `/admin/news/${newsId}`;
export const postNews = '/admin/news';
export const postNewsDetail = (newsId: number | string) => `/admin/news/${newsId}`;
export const deleteNewsDetail = (newsId: number | string) => `/admin/news/${newsId}`;

/* Project manage */
export const getProjectList = (projectType: string) => `/admin/project/${projectType}/type`;
export const getProjectDetail = (projectId: number | string) => `/admin/project/${projectId}`;
export const postProjectCreate = '/admin/project';
export const postProjectDetail = (projectId: number | string, step: number) => `/admin/project/${projectId}/step/${step}`;
export const putProjectName = (projectId: number) => `/admin/projectName/${projectId}`;
export const putProjectTransfer = (projectId: number) => `/admin/project/${projectId}/transfer`;
export const deleteProjectDetail = (projectId: number) => `/admin/project/${projectId}`;

/* Progress manage */
export const getProgressList = (projectId: number | string) => `/admin/progress/${projectId}/project`;
export const getProgressDetail = (progressId: number | string) => `/admin/progress/${progressId}`;
export const postProgressDetail = '/admin/progress';
export const putProgressDetail = (progressId: number | string) => `/admin/progress/${progressId}`;
export const deleteProgress = (progressId: number | string) => `/admin/progress/${progressId}`;

/* Progress sms manage */
export const getSmsLogList = (progressId: number | string) => `/admin/progress/${progressId}/smslog`;
export const postSendSms = '/admin/progress/smSend';

/* Resident manage */
export const getResidentList = (projectId: number | string) => `/admin/user/${projectId}/project`;
export const getResidentDetail = (userId: number | string) => `/admin/user/${userId}`;
export const postResidentDetail = '/admin/user';
export const putResidentDetail = (userId: number | string) => `/admin/user/${userId}`;
export const deleteResidentDetail = (userId: number | string) => `/admin/user/${userId}`;

/* Service Form manage */
export const getFormList = (formType: number | string) => `/admin/form/${formType}/type`;
export const getFormDetail = (formId: number | string) => `/admin/form/${formId}`;
export const putFormDetail = (formId: number | string) => `/admin/form/${formId}`;

/* Admin manage */
export const getAdminList = '/admin';
export const postCreateAdmin = '/admin';
const getAdminDetailPath = '/admin';
export const getAdminDetail = (adminId: number|string) => `${getAdminDetailPath}/${adminId}`;
export const putAdminDetail = (adminId: number|string) => `${getAdminDetailPath}/${adminId}`;
export const deleteAdmin = (adminId: number|string) => `${getAdminDetailPath}/${adminId}`;
